import { render, staticRenderFns } from "./JingdongOrderList.vue?vue&type=template&id=7a5b974e&scoped=true"
import script from "./JingdongOrderList.vue?vue&type=script&lang=js"
export * from "./JingdongOrderList.vue?vue&type=script&lang=js"
import style0 from "./JingdongOrderList.vue?vue&type=style&index=0&id=7a5b974e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5b974e",
  null
  
)

export default component.exports